import { render, staticRenderFns } from "./TutorialSystem.vue?vue&type=template&id=3ccfa7fb&scoped=true"
import script from "./TutorialSystem.vue?vue&type=script&lang=js"
export * from "./TutorialSystem.vue?vue&type=script&lang=js"
import style0 from "./TutorialSystem.vue?vue&type=style&index=0&id=3ccfa7fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccfa7fb",
  null
  
)

export default component.exports